import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaEdit } from "react-icons/fa";
import { FaEye, FaPlus } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";

import { CheckCircle, XCircle } from "lucide-react";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Tooltip,
  Alert,
  Snackbar,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../common/CommonModal";
import ic_no_data from "../../utils/ic_no_data_to_show.svg";
import ic_timeline_circle_indicator from "../../utils/ic_timeline_icon.svg";
import { format, set } from "date-fns";


const CustomerCreationRequest = () => {
  const location = useLocation();
  const customerType = location.state?.customerType;

  const [tableRows, setTableRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const receiptsPerPage = 10;
  const limit = 50;
  const [isLoading, setIsLoading] = useState(true);

  const totalPages = Math.ceil(filteredRows.length / receiptsPerPage);
  const navigate = useNavigate();

  const [isApproveRejectModalOpen, setIsApproveRejectModalOpen] =
    useState(false);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const paginate = (pageNumber) => {
    if (pageNumber >= 1) setCurrentPage(pageNumber);
  };

    const [voucherTimeLineList, setVoucherTimeLineList] = useState([]);
  

  const fetchDocumentTableCustomer = async (page = 1, search) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let apiURL = "";

    apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${companyCode}/CREDITCUSTREQ/-/-`;

    try {
      const response = await axios.get(apiURL);
      setTableRows(response.data || []);
      setFilteredRows(response.data || []);
    } catch (err) {
      console.error("Error while fetchDocumentTableCustomer", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchDocumentTableCustomer(currentPage, searchTerm);
    }, 100);

    return () => clearTimeout(delay);
  }, [searchTerm, customerType, currentPage]);

  // ✅ Filter table when searchTerm changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredRows(tableRows);
    } else {
      console.log('tableRows:',tableRows)
      const filtered = tableRows?.filter(
        (rec) =>
          String(rec.autoid).includes(searchTerm) ||
          rec?.accdesc?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredRows(filtered);
    }
  }, [searchTerm, tableRows]);

  const onCustomerCreation = () => {
    navigate(`/customerCreation`);
    // window.location.reload(); // forces full refresh
  };

  const handleApprovalSubmit = async () => {
    console.log("approvalStatus:", approvalStatus);
    if (approvalStatus === "reject" && !rejectionReason.trim()) {
      alert("Please provide a reason for rejection");
      return;
    }

    setApprovalLoading(true);
    try {
      let companyCode = localStorage.getItem("companyCode") || "-";
      let department = localStorage.getItem("currentSelectedDepartment") || "-";
      let userID = localStorage.getItem("currentUserEmployeeID") || "-";
      const payload = [
        {
          cmpcode: companyCode,
          doc_no: selectedRow.autoid,
          status: approvalStatus === "approve" ? "ACCEPTED" : "REJECTED",
          evaluationcomments:
            approvalStatus === "reject" ? rejectionReason : "Accepted",
          userid: userID,
          deptno: department,
          doctype: "CUSTCREATIONREQ",
        },
      ];

      console.log("Payload:", payload);
      let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const url = `${apiPaths[0]?.API_CONFIG}/api/CRMDocStatusUpdate`;

      const response = await axios.post(url, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("Sales order Approval API Response:", response.data);

      await fetchDocumentTableCustomer();
      setSnackbar({
        open: true,
        message:
          approvalStatus === "approve"
            ? "Customer request approved successfully!"
            : "Customer request rejected successfully!",
        severity: "success",
      });
      setIsApproveRejectModalOpen(false);
      // navigate('/')
    } catch (error) {
      console.error("Error processing approval:", error);
      //   alert("Failed to process approval: " + error.message);
      setSnackbar({
        open: true,
        message: `Failed to process approval: ${error.message}`,
        severity: "error",
      });
    } finally {
      setApprovalLoading(false);
    }
  };

  const handleAction = (rec) => {
    fetchTransactionLogsData()
    setIsApproveRejectModalOpen(true);
    setSelectedRow(rec);
  };
  const handleCheckStatment = (rec) => {
    if (!rec || !rec["SO NO"]) {
      console.error("SO NO not found in record:", rec);
      return;
    }

    const soNoToSend = rec.autoid;
    console.log("soNoToSend:", soNoToSend);

    navigate("/statements", {
      state: {
        soNo: soNoToSend.trim(),
      },
    });
  };


    const fetchTransactionLogsData = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
     let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let companyCode = localStorage.getItem("companyCode") || "-";
    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskHistoryList/${companyCode}/CUSTCREATIONREQ/${department}/${selectedRow.autoid}`;
    try {
      const response = await axios.get(url);

      console.log("response.data transaction logs::", response.data);
      const data = response.data;

      setVoucherTimeLineList(data);
    } catch (error) {
      console.error("Error fetching transaction logs:", error);
    }
  };

  return (
    <div className="mx-2">
      <div className="flex flex-wrap items-center justify-between gap-16 mt-2">
        <div className="flex gap-12 justify-between items-center ">
          <h2 className="text-lg text-gray-800 ">Customer Creation Request Approval</h2>

          {/* <RadioGroup
            row
            name="customerType"
            value={customerType}
            disabled
            className="flex items-center"
          >
            <FormControlLabel
              value="Customer"
              control={<Radio size="small" color="default" />}
              label="Customer"
            />
            <FormControlLabel
              value="Supplier"
              control={<Radio size="small" color="default" />}
              label="Supplier"
            />
          </RadioGroup> */}
        </div>

        <div className="flex justify-end items-center">
          <input
            // type="text"
            placeholder="Search by ID or Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-[300px]  px-3 py-2 shadow-sm text-sm rounded-md bg-white border border-gray-300 placeholder-gray-400 focus:outline-none focus:border-gray-400"
          />
        </div>

        <div className="">
          {/* Back Button */}
          {/* <button
            onClick={onBack}
            className="hidden relative bg-gray-600 text-white font-medium text-[17px] px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
          >
            <span className="mr-10">Back</span>
            <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
              <FaArrowLeft className="text-gray-600" />
            </div>
          </button> */}
          {/* <button
            onClick={onCustomerCreation}
            className="relative ml-4 bg-green-600 text-white font-medium text-[17px] px-2 py-[0.35em]  h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer   group"
          >
            <span className="mr-8">New</span>
            <div className="absolute right-[0.3em] bg-white h-[1.2em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]  active:scale-95">
              <FaPlus className=" text-green-600 " />
            </div>
          </button> */}
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4 max-h-[60vh]">
        <table className="min-w-full bg-white border border-gray-200 text-sm shadow-sm">
          <thead className="bg-gray-100 text-sm sticky top-0 z-20 shadow-sm">
            <tr>
              {[
                "Auto ID",
                "Name",
                "Territory",
                "City",
                "Street",
                "Area Code",
                "Country",
                "Contact",
                "Primary Phone",
                "Alternate Phone",
                "Email",
                "Comment",
                "C.Limit",
                "Salesman",
                "TRN",
                "Patron Type",
                "Action",
              ].map((header) => (
                <th
                  key={header}
                  className="px-4 py-1 font-semibold text-gray-700 border text-left"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredRows.length > 0 ? (
              filteredRows.map((rec, index) => (
                <tr
                  key={index}
                  className={`hover:bg-blue-50 border ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-4 w-30 py-2 border text-xs text-left">
                    {rec.autoid || "-"}
                  </td>
                  <td className="px-4 py-2 w-54  border text-[0.78em] text-left">
                    {rec.accdesc || "-"}
                  </td>
                  <td className="px-4  w-46  py-2 border text-xs text-left">
                    {rec.address1 || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.address2 || "-"}
                  </td>
                  <td className="px-4 py-2 w-36  border text-[0.78em] text-left">
                    {rec.address3 || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.area_code || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.country || "-"}
                  </td>
                  <td className="px-4 py-2 w-36  border text-xs text-left">
                    {rec.Contact || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.Primary_Phone || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.Alt_Phone || "-"}
                  </td>

                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.Email || "-"}
                  </td>

                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.Comment || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.climit || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.sale_man || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.TRN || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.patrontype || "-"}
                  </td>

                  <td className="px-2 py-1 border-b text-xs text-gray-600 ">
                    <div className="flex justify-end gap-2">
                      {/* <Tooltip title="Action" arrow> */}
                      {/* <button
                        onClick={() => handleCheckStatment(rec)}
                        className="px-2 py-1 rounded text-white bg-blue-600 flex items-center gap-1 text-xs hover:bg-blue-700"
                      >
                        Check Statement
                      </button> */}
                      <button
                        onClick={() => handleAction(rec)}
                        className="px-2 py-1 rounded text-white bg-green-600 flex items-center gap-1 text-xs hover:bg-green-700"
                      >
                        <FiSettings size={14} /> Action
                      </button>
                      {/* </Tooltip> */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center py-6 text-gray-500">
                  {isLoading ? "Loading Data..." : "No Matching Records Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-between bg-gray-100 items-center px-2 py-4 shadow-sm rounded-md mt-2">
        <div className="text-sm text-gray-600">
          Showing page {currentPage} ({filteredRows.length} rows)
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 text-xs rounded-lg ${
              currentPage === 1
                ? "bg-gray-200 cursor-not-allowed"
                : "bg-green-600 text-white hover:bg-green-700"
            }`}
          >
            Previous
          </button>
          {/* <span className="px-3 py-1 text-xs text-gray-700">
            Page {currentPage} of {totalPages}
          </span> */}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || filteredRows.length === 0}
            className={`px-3 py-1 text-xs rounded-lg ${
              currentPage === totalPages || filteredRows.length === 0
                ? "bg-gray-200 cursor-not-allowed text-gray-500"
                : "bg-green-600 text-white hover:bg-green-700"
            }`}
          >
            Next
          </button>
        </div>
      </div>
      {/* Approve/Reject Modal */}
      <Modal
        isOpen={isApproveRejectModalOpen}
        onClose={() => setIsApproveRejectModalOpen(false)}
        title={`${
          approvalStatus === "approve" ? "Approve" : "Reject"
        } ${"Customer Creation Request"} `}
      >
        <div className="space-y-4 p-2 px-4">

          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600 mb-1">{`${"Customer Creation Request:"} `}</p>
            <p className="font-semibold text-gray-900">
              {/* {selectedRowData?.["SO NO"]  || "N/A"} */}
              {selectedRow.accdesc || "N/A"}  <span>#{selectedRow.autoid || "N/A"}</span>
            </p>
          </div>
          <div>
        {/* <label className="block text-sm font-medium mb-1">
                
              </label> */}
        <h2 className="text-md font-semibold text-gray-800 ">
          Transaction Logs
        </h2>
        <div
          className="bg-[#F3F4F6]  rounded border"
          style={{
            height: "160px",
            overflowY: "scroll",
            padding: "6px",
            // marginRight: "10px",
          }}
        >
          {voucherTimeLineList ? (
            voucherTimeLineList.length > 0 ? (
              voucherTimeLineList?.map((item) => {
                return (
                  <div className=" bg-white border rounded shadow p-1 m-2">
                    <p className="flex">
                      <div>
                        <img src={ic_timeline_circle_indicator} />
                      </div>
                      <div className="ms-2  w-full">
                        <div className="flex justify-between items-center">
                          <div>
                            <span className="text-xs font-semibold">
                              {format(item.create_date, "dd-MM-yyyy")}{" "}
                            </span>
                            <span
                              className="text-xs font-semibold"
                              style={{ marginLeft: "5px" }}
                            >
                              {format(item.create_date, "hh:mm a")}{" "}
                            </span>
                            <span
                              className="text-xs font-semibold"
                              style={{ marginLeft: "5px" }}
                            >
                              User: {item.userid}
                            </span>
                          </div>
                          <div className="px-1">
                            <span className="bg-gray-100 text-gray-400 text-xs font-medium me-2 px-1.5 py-0.5 rounded dark:bg-gray-700 dark:text-white">
                              {" "}
                              {item.status}{" "}
                            </span>
                          </div>
                        </div>
                        <div>
                          <span>{item.Comments}</span>
                        </div>
                      </div>
                    </p>
                  </div>
                );
              })
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img style={{ width: "90px" }} src={ic_no_data} />
                <p className="p-2 text-slate-500">
                  {" "}
                  No data in Transaction logs
                </p>
              </div>
            )
          ) : (
            <p>Unable to fetch Transaction Logs.</p>
          )}
        </div>
      </div>

          <div className="flex gap-2">
            <button
              onClick={() => setApprovalStatus("approve")}
              className={`flex-1 px-4 py-2 rounded-lg border-2 transition-all ${
                approvalStatus === "approve"
                  ? "border-green-500 bg-green-50 text-green-700"
                  : "border-gray-300 bg-white text-gray-700 hover:border-green-300"
              }`}
            >
              <CheckCircle className="inline-block mr-2" size={18} />
              Approve
            </button>
            <button
              onClick={() => setApprovalStatus("reject")}
              className={`flex-1 px-4 py-2 rounded-lg border-2 transition-all ${
                approvalStatus === "reject"
                  ? "border-red-500 bg-red-50 text-red-700"
                  : "border-gray-300 bg-white text-gray-700 hover:border-red-300"
              }`}
            >
              <XCircle className="inline-block mr-2" size={18} />
              Reject
            </button>
          </div>

          {approvalStatus === "reject" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Reason for Rejection <span className="text-red-500">*</span>
              </label>
              <textarea
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                placeholder="Please provide a reason for rejecting this sales order..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                rows={4}
              />
            </div>
          )}

          <div className="flex gap-2 justify-end pt-2">
            <button
              onClick={() => setIsApproveRejectModalOpen(false)}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              disabled={approvalLoading}
            >
              Cancel
            </button>
            <button
              onClick={handleApprovalSubmit}
              disabled={approvalLoading || !approvalStatus}
              className={`px-4 py-2 rounded-lg text-white transition-colors ${
                approvalStatus === "approve"
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-red-600 hover:bg-red-700"
              } disabled:opacity-50 disabled:cursor-not-allowed`}
            >
              {approvalLoading
                ? "Processing..."
                : `${
                    approvalStatus === "approve" ? "Approve" : "Reject"
                  } Order`}
            </button>
          </div>
        </div>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CustomerCreationRequest;
